import { types } from './index';

export const getGallery = () => ({
    type: types.GALLERY_REQUEST
});
